import { List } from "@mui/material";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import React from "react";
import { AudienceFilter } from "./AudienceFilter";
import { LocationFilterControl } from "./LocationFilter";
import { FacetControl } from "./FacetFilterControl";

export const LSSearchFilters = () => {
  const { locationConfiguration } = useLocationConfiguration();
  const { facetDisplayInformations, displaySettings } =
    locationConfiguration?.pacSettings || {};

  return (
    <List dense={true}>
      <LocationFilterControl></LocationFilterControl>
      {displaySettings?.displayAudienceCharacteristicsFilter && (
        <AudienceFilter></AudienceFilter>
      )}
      {facetDisplayInformations
        .filter((fdi) => fdi.displayed)
        .map((fdi) => (
          <FacetControl key={fdi.name} facet={fdi} />
        ))}
    </List>
  );
};
